/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It uses the standard amortization formula on the monthly interest rate (annual rate ÷ 12). A zero-interest loan simply splits the amount evenly across the months.`)
};

const es_ln_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliza la fórmula de amortización estándar en la tasa de interés mensual (tasa anual ÷ 12). Un préstamo sin interés simplemente divide el monto uniformemente en los meses.`)
};

const de_ln_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie verwendet die Standard-Tilgungsformel auf den monatlichen Zinssatz (Jahreszins ÷ 12). Bei einem zinsfreien Darlehen wird der Betrag einfach gleichmäßig auf die Monate aufgeteilt.`)
};

const nl_ln_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het gebruikt de standaard afschrijvingsformule op het maandelijkse rentepercentage (jaarlijkse rente ÷ 12). Een lening zonder rente verdeelt het bedrag eenvoudig gelijkmatig over de maanden.`)
};

const fr_ln_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il utilise la formule d'amortissement standard sur le taux d'intérêt mensuel (taux annuel ÷ 12). Un prêt sans intérêt divise simplement le montant uniformément sur les mois.`)
};

const it_ln_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizza la formula standard di ammortamento al tasso di interesse mensile (tasso annuale ÷ 12). Un prestito senza interessi divide semplicemente l'importo in modo uniforme nei mesi.`)
};

const pt_br2_ln_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa a fórmula de amortização padrão na taxa de juros mensal (taxa anual ÷ 12). Um empréstimo sem juros simplesmente divide o montante uniformemente pelos meses.`)
};

const pt_ln_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliza a fórmula de amortização padrão sobre a taxa de juro mensal (taxa anual ÷ 12). Um empréstimo sem juro simplesmente divide o montante equitativamente pelos meses.`)
};

const ja_ln_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「月利率に標準償却公式を使用します（年利率÷12）。金利がゼロのローンは、金額を単純に月数で均等に分割します。」`)
};

const zh_ln_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算采用标准的分期偿还公式，作用于月利率（年利率 ÷ 12）。如果利率为零，贷款金额会被平均分摊到各个月份。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_faq1_a", locale)
	if (locale === "en") return en_ln_faq1_a(inputs)
	if (locale === "es") return es_ln_faq1_a(inputs)
	if (locale === "de") return de_ln_faq1_a(inputs)
	if (locale === "nl") return nl_ln_faq1_a(inputs)
	if (locale === "fr") return fr_ln_faq1_a(inputs)
	if (locale === "it") return it_ln_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_ln_faq1_a(inputs)
	if (locale === "pt") return pt_ln_faq1_a(inputs)
	if (locale === "ja") return ja_ln_faq1_a(inputs)
	return zh_ln_faq1_a(inputs)
};